<div class="data" [ngClass]="status">
  <div class="divChart">
    <canvas id="pie{{status}}" width="350" height="150"></canvas>
  </div>
</div>
